import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface LegalLayoutProps {
  title: string;
  eyebrow: string;
  lastUpdated: string;
  children: ReactNode;
}

export function LegalLayout({ title, eyebrow, lastUpdated, children }: LegalLayoutProps) {
  return (
    <>
      <header className="flex items-center justify-between border-b border-rule-soft px-7 py-5">
        <Link
          to="/"
          className="font-display text-2xl tracking-[-0.04em] text-ink [font-variation-settings:'opsz'_96,'SOFT'_80,'WONK'_1,'wght'_500]"
        >
          Varo
        </Link>
        <Link
          to="/"
          className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-mute hover:text-terra"
        >
          Back to Varo →
        </Link>
      </header>
      <main className="mx-auto max-w-2xl px-7 py-16">
        <p className="eyebrow eyebrow-accent">{eyebrow}</p>
        <h1 className="mt-3 mb-3 text-5xl tracking-tight">{title}</h1>
        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-mute mb-10">
          Last updated · {lastUpdated}
        </p>
        <div className="legal-prose">{children}</div>
        <hr className="my-12 border-t border-rule" />
        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-mute">
          Questions? Email{" "}
          <a className="uline" href="mailto:hello@varo.biz">
            hello@varo.biz
          </a>
          .
        </p>
      </main>
    </>
  );
}
